import React from 'react';
import { CheckCircle, Globe, Beaker, Microscope } from 'lucide-react';
export function Ecosystem() {
  const ecosystemParts = [{
    name: 'CalMiR',
    description: 'Research & clinical trials (academic credibility)',
    icon: <Microscope className="text-teal-600" size={24} data-id="element-153" data-mp="vyr76ya5i96y" />,
    color: 'bg-teal-100',
    link: '/research'
  }, {
    name: 'CalBiome',
    description: 'Product innovation & microbiota reset protocols',
    icon: <Beaker className="text-navy-600" size={24} data-id="element-154" data-mp="mxkoqjnxyob2" />,
    color: 'bg-navy-100',
    link: '/calbiome'
  }, {
    name: 'Ukweli Institute',
    description: 'Independent certification & consumer trust',
    icon: <CheckCircle className="text-teal-600" size={24} data-id="element-155" data-mp="82mrpdhulann" />,
    color: 'bg-teal-100',
    link: '/certification'
  }, {
    name: 'Afya Program',
    description: 'Global outreach & health equity',
    icon: <Globe className="text-navy-600" size={24} data-id="element-156" data-mp="22g5xfam17zk1" />,
    color: 'bg-navy-100',
    link: '/about/afya-program'
  }];
  return <section className="py-16 bg-navy-50" data-id="element-157" data-mp="2m43hteny8h2a">
      <div className="container mx-auto px-4" data-id="element-158" data-mp="2r4hpuwpjvr0b">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-159" data-mp="2r6cbyeck5p5z">
          <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-160" data-mp="2c80dc25mk6c6">
            The CalMiR Ecosystem
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-161" data-mp="2h5s8r65haal4"></div>
          <p className="text-navy-700" data-id="element-162" data-mp="34w5y2owohvc0">
            CalMiR operates at the center of a four-part ecosystem, creating a
            closed loop of science → validation → productization → adoption.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-163" data-mp="2v74lz9t97y3b">
          {ecosystemParts.map((part, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-164" data-mp="3044sflu0n2uy" data-mpi={index}>
              <div className={`${part.color} p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4`} data-id="element-165" data-mp="3slgvbwetl7le">
                {part.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-166" data-mp="1d8fm3q67yat">
                <a href={part.link} className="hover:text-teal-600 transition-colors" data-id="element-167" data-mp="1e1j8vtu27oq">
                  {part.name}
                </a>
              </h3>
              <p className="text-navy-700" data-id="element-168" data-mp="3ok2990w71ruc">{part.description}</p>
            </div>)}
        </div>
        <div className="mt-12 max-w-3xl mx-auto text-center" data-id="element-169" data-mp="3jkpmsh98imsa">
          <p className="text-navy-700 italic" data-id="element-170" data-mp="3eqlcbo0rfwmg">
            "Together, this creates a closed loop of science → validation →
            productization → adoption."
          </p>
        </div>
      </div>
    </section>;
}